import React, { useState } from 'react'
import scout1 from '../../../images/home/Scout-1-Secret-of-the-Swamp-2020-s.jpg';
import stefan from '../../../images/home/StefanDerksen-4.jpg';
import scout2 from '../../../images/home/Scout-Haunted-Cover-4.jpg';
import { Link } from 'react-router-dom';

import './trust-box.scss';



/**
 * TrustBox Component
 * It contains reason for company trust. There is an image and its legend
 * 
 * @param {object} props The component's properties
 */
function TrustBox(props) {

   const [link, setLink] = useState('');

   /**
    * It generates an image based on the value of the props.image
    * 
    * @param {object} props The TrustBox component's properties
    */
   const getImage = () => {

      switch(props.image) {
         case 1:
            if (!link) {
               setLink('products/16234')
            }
            return <img src={scout1} alt="Scout - The Secret of the Swamp2"></img>;
         case 2:
            if (!link) {
               setLink('products/10009')
            }
            return <img src={stefan} alt="Parcel"></img>;
         case 3:
            if (!link) {
               setLink('products/10506')
            }
            return <img src={scout2} alt="Save money"></img>;
         default:
            console.error('Image number unexpected. Showing no image.');
            return <p>No Image!</p>
      }
   }

   return (
      
      <div className="container trust-box">
         <div className="row justify-content-center trust-box-1">
            <Link to={link}>{getImage(props)}</Link>
         </div>

         <div className="row justify-content-center trust-box-2">
            <div className="trust-box-line"></div>
         </div>
         
         <div className="row justify-content-center trust-box-3">
            <p>{props.text}</p>
            <p>{props.customer}</p>
         </div>
      </div>
   )
}

export default TrustBox